import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateImportRequestsShow } from '@/types/serializers';

export const useFetchCandidateImportRequest = (
  encryptId: string | undefined,
  options?: {
    refetchInterval?: number | false;
  }
) => {
  return useQuery({
    queryKey: ['candidateImportRequest', encryptId],
    queryFn: async () => {
      if (!encryptId) throw new Error('encryptId is required');

      const response = await fetch(`/agent/api/candidate_import_requests/${encryptId}`, {
        headers: {
          'X-CSRF-Token':
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '',
        },
      });

      if (!response.ok) {
        throw new Error('データの取得に失敗しました');
      }

      const data: AgentApiCandidateImportRequestsShow = await response.json();
      return data;
    },
    enabled: !!encryptId,
    refetchInterval: options?.refetchInterval,
  });
};
